export default "__VITE_ASSET__ZAiCh2Vn__"